<template>
  <div class="kompa-list-index-view">
    <h1>{{$t('titles.index')}}</h1>

    <link-button type="primary" :to="{ name: 'create-kompa-product' }" icon="plus">
      {{$t('actions.new')}}
    </link-button>

    <search-input ref="search" v-model="searchQuery" class="uk-align-right" />

    <data-grid :columns="gridColumns"
               :sortable="[]"
               :rows="kompaProducts.entries"
               :page-info="kompaProducts.pagination"

               :is-loading="isLoading"
               @sort="sortBy"
               v-if="gridLoaded"
               class="uk-margin-medium">
      <span slot="empty">{{$t('hints.empty')}}</span>
      <template slot="row" scope="props">
        <td>
          <router-link :to="{ name: 'edit-kompa-product',
                              params: { id: props.row.id } }">
            <span :class="{'deleted': props.row.deletedAt}">{{props.row.name}}</span>
          </router-link>
        </td>
        <td>
          <span :class="{'deleted': props.row.deletedAt}">{{props.row.brand}}</span>
        </td>
        <td>
          <data-grid-actions :edit-route="{ name: 'edit-kompa-product',
                                            params: { id: props.row.id } }"
                             @remove="deleteRecordWhenConfirmed(props.row)" />
          <button v-if=props.row.deletedAt @click="undeleteRecord(props.row)" class="uk-button uk-button-small">Undelete</button>
        </td>
      </template>
    </data-grid>

    <div class="loader-container uk-container uk-margin-medium-top uk-text-center" v-else>
      <loader />
    </div>
  </div>
</template>

<script>
import kompaProductsQuery from '@/api/queries/kompa-list.graphql';
import deleteProductMutation
  from '@/api/mutations/delete-kompa-product.graphql';
import undeleteProductMutation
  from '@/api/mutations/undelete-kompa-product.graphql';
import IndexView from '@/mixins/IndexView';

export default {
  name: 'kompa-list-index-view',
  mixins: [
    IndexView('kompaProducts', {
      gridFields: ['name', 'brand'],
      listQuery: kompaProductsQuery,
      deleteMutation: deleteProductMutation,
      undeleteMutation: undeleteProductMutation,
      nameField: 'name',
    }),
  ],
  i18n: {
    messages: {
      de: {
        actions: {
          new: 'Produkt anlegen',
        },

        hints: {
          empty: 'Keine Produkte gefunden.',
        },
        titles: {
          index: 'Kompa Liste',
        },
      },
    },
  },
};
</script>

<style>
  span.deleted {
    text-decoration: line-through
  }
</style>



// WEBPACK FOOTER //
// IndexView.vue?163d951a